module.exports = __webpack_public_path__ + "static/media/dsmjs-optimized.fa98004b.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/01-intro/assets/dsmjs-optimized.png
// module id = 926
// module chunks = 0